// extracted by css-extract-rspack-plugin
export default {"root":"mOF5Yf"};